import { NgTemplateOutlet } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
import { AutoSuggestSymbol, SymbolType } from '../../domain/public-api';
import { IconFlagComponent } from '../../components/icon/icon-flag.component';
import { SymbolLookupHighlightPipe } from './symbol-lookup.highlight.pipe';

@Component({
  selector: 'td-wb-symbol-lookup-item-label',
  templateUrl: 'symbol-lookup-item-label.component.html',
  styleUrls: ['symbol-lookup-item-label.component.scss'],
  imports: [
    TranslateDirective,
    SymbolLookupHighlightPipe,
    IconFlagComponent,
    NgTemplateOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SymbolLookupItemLabelComponent {
  @Input() item: AutoSuggestSymbol;
  @Input() highlight: string;
  @Input() compact: boolean = false;

  isMutualFund(): boolean {
    return this.item !== undefined && this.item.symbolType === SymbolType.MUTUALFUND;
  }
}
